import Token from "@routes/providers/token";
import User from "@routes/providers/user";
import UserAgreement from "@routes/providers/userAgreement";

const RoutesWrapper = ({ children }) => {
    return (
        <Token>
            <User>{children}</User>
        </Token>
    );
};

export default RoutesWrapper;
